<template>
    <div class="form-item">
        <label class="label-caption">Resultado</label>
        <select :value="resultadoSelecionado" @change="atualizarOpcao" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        ckAddTodos: {type: Boolean, default: false},
        resultadoSelecionado: {type: String, default: null}
    },

    computed: {
        lsTipos() {
            const tipos = [
                { id: 'CF', descricao: 'CONFORME' },
                { id: 'NC', descricao: 'NÃO CONFORME' },
                // { id: 'NA', descricao: 'NÃO AVALIADO' },
            ];
            if (this.ckAddTodos) {
                tipos.unshift({ id: '.', descricao: 'TODAS' });
            }
            return tipos;
        }
    },

    methods: {
        atualizarOpcao(event) {
            this.$emit('update:resultadoSelecionado', event.target.value);
        }
    }
};
</script>